import { z } from 'zod';
import { getMaxUTCDateString } from '../utils';

const decideOnExtensionActions = ['grant', 'deny'] as const;
type IDecideOnExtensionAction = (typeof decideOnExtensionActions)[number];

export type IDeadlineExtensionDecisionFormData = {
  action?: IDecideOnExtensionAction;
  deadline: string;
};

export const decideOnExtensionSchema = z
  .object({
    action: z.enum(decideOnExtensionActions, {
      message: 'Please select one of the available options.'
    }),
    deadline: z.string().optional()
  })
  .refine(
    data => {
      if (data.action === 'grant') {
        return !!data.deadline;
      }
      return true;
    },
    {
      message: 'Please enter a new deadline date.',
      path: ['deadline']
    }
  );

export const dateSchema = (startDate = '') => {
  const minDate = startDate ? new Date(startDate) : new Date();
  const maxDate = new Date(getMaxUTCDateString(minDate.toUTCString()));

  return z.coerce
    .date()
    .min(minDate, {
      message: `Date must be on or after ${minDate.toLocaleDateString('en-CA', { timeZone: 'UTC' })}`
    })
    .max(maxDate, {
      message: `Date must be on or before ${maxDate.toLocaleDateString('en-CA', { timeZone: 'UTC' })}`
    });
};

export const getExtensionSchema = (startDate = '') =>
  z.object({
    proposedDate: dateSchema(startDate)
  });
